import React from 'react';
import AddDefectForm from '../components/AddDefectForm';

const AddDefectTestPage = () => {
    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: '#f1f5f9',
            padding: '20px'
        }}>
            <AddDefectForm />
        </div>
    );
};

export default AddDefectTestPage;